import React from "react";
import { Typography } from "antd";
import Headshot from "@components/Player/Headshot";
import { StatusAvatarGroup } from "./StatusAvatarGroup";

const { Text } = Typography;

// Pure — the left player card. Container supplies headshotSrc (useHeadshot) + counts.
export const PlayerCardView = ({ player, headshotSrc, teamLogo, counts = [] }) => (
    <div
        className="stv2-tracker-player-card"
        style={counts.length > 0 ? { justifyContent: "space-between" } : { justifyContent: "flex-start" }}
    >
        <div style={{ width: "125px" }}>
            <Headshot
                headshot={headshotSrc}
                team_logo={teamLogo}
                useOverlay={player["use_overlayed_headshot"]}
                compact={true}
            />
        </div>
        <div className="stv2-tracker-player-card-info">
            <Text> {`${player?.first_name} ${player?.last_name}`} </Text>
            <Text type="secondary"> {player?.position} | {player?.number} </Text>
        </div>
        {counts.length > 0 && (
            <div className="stv2-tracker-player-card-status-count">
                <StatusAvatarGroup counts={counts} keyPrefix={`${player.player_id}`} />
            </div>
        )}
    </div>
);
